import { useMemo } from "react";
import { usePlaceOutingSignals } from "@/hooks/usePlaceOutingSignals";
import { useBatchCovers } from "@/hooks/useBatchCovers";
import { UtflyktCard } from "./UtflyktCard";

/**
 * "Förslag nära dig" section for Explore.
 * Shows places with outing signals (events, farm shop, farm sale, intents).
 * Renders as a horizontal scroller on mobile, wrapping grid on desktop.
 */
export function UtflyktSection() {
  const { data: signals, isLoading } = usePlaceOutingSignals(10);

  const placeIds = useMemo(
    () => (signals ?? []).map((s) => s.place_id),
    [signals],
  );
  const { coverMap } = useBatchCovers("place", placeIds, 320);

  if (isLoading || !signals || signals.length === 0) return null;

  return (
    <div>
      <div className="px-4 pt-6 pb-3">
        <h2 className="text-lg font-semibold text-foreground leading-tight">
          Förslag nära dig
        </h2>
        <p className="text-sm text-muted-foreground mt-0.5">
          Utflykter med aktiviteter, gårdsbutik och gårdsförsäljning
        </p>
      </div>

      <div
        className="flex gap-3 overflow-x-auto scrollbar-none px-4 pb-2"
        style={{ WebkitOverflowScrolling: "touch" }}
      >
        {signals.map((signal) => (
          <div key={signal.place_id} className="shrink-0 w-[260px]">
            <UtflyktCard
              signal={signal}
              coverUrl={coverMap.get(signal.place_id) ?? null}
            />
          </div>
        ))}
      </div>
    </div>
  );
}
